import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import LabelModal from './LabelModal';

function CreateLabel() {
	const [show, setShow] = useState(false);
	const handleClose = () => {
		setShow(false);
	};
	return (
		<div>
			<Button className="mr-2" variant="dark" onClick={() => setShow(true)}>
				Create Label
			</Button>

			{show && <LabelModal show={show} handleClose={handleClose} />}
		</div>
	);
}

export default CreateLabel;
